'use-strict'
import app from '../../../data/base';
import moment, { normalizeUnits } from 'moment';

const validateRequiredField = (inputvalue) => {
    if(inputvalue==null || inputvalue==''){
        return false;
    }else
        return true;
}

const validateGruppoRelatori = (inputobject, isedit) => {
    const result = [];
    console.log(inputobject);

    if(!validateRequiredField(inputobject.name)){
        result.push({field : 'Nome', error : 'Campo obbligatorio'});
    }

    if(inputobject.group && !validateRequiredField(inputobject.group.id)){
        result.push({field : 'Gruppo', error : 'Campo obbligatorio'});
    }

    return result;
}

const gruppirelatori = {
    auth: {
        onAuthStateChanged: app.auth.onAuthStateChanged
    },
    methods : {
      callserver : app.methods.callserver,
      validateGruppoRelatori : validateGruppoRelatori,
    }
  };
  export default gruppirelatori;
